<script>
  import { link } from "svelte-spa-router";
  import { createEventDispatcher, onMount } from "svelte";
  import axios from "axios";
  import { fade } from "svelte/transition";
  import config from "../../stores/config";
  import * as ls from "local-storage";
  import FluxViewModal from "./FluxViewModal.svelte";
  import loadData from "../../utils/loadData";

  const authData = { headers: { authorization: ls.get("jwt") } };

  export let _id;
  export let name;
  export let price;
  export let inventoryLevel;
  export let reorderLevel;
  export let supplierID;
  export let SKU;
  export let flux;
  export let class_;
  export let lotNumber;
  export let length;
  export let width;
  export let thickness;
  export let bundlePrice;
  export let totalMM;
  export let materialProvider;
  export let plankNumber;
  export let lastStockTake;

  let avg = price;
  let K = 0;
  let plankPrice;

  onMount(() => {
    if (/timber|foam|board|pine/.test(class_)) {
      K = $config.K.find((el) => el._id == lotNumber).total;
      plankPrice = Number((totalMM / K) * bundlePrice).toFixed(2);
    }
    if (flux?.length > 0) {
      avg = flux.map(({ p }) => p).reduce((a, b) => a + b, 0) / flux.length;
    }
  });

  let mult = (a, b) => {
    let result = Number.parseFloat(a) * Number.parseFloat(b);
    return result.toFixed(2);
  };

  const dispatch = createEventDispatcher();

  const handleDelete = async () => {
    let resItem = await axios.get(
      `${$config.backendURL}/fstyles/with-item/${_id}`,
      authData
    );

    let usedIn = resItem?.data?.usedIn;

    console.log(usedIn);

    if (usedIn) {
      alert(
        `${name} is being used in a Job Card.\n\nYou cannot delete this record at the moment!`
      );
      return;
    }

    let confirmDelete = confirm(`Do you wish to delete ${name}?`);

    if (confirmDelete) {
      axios
        .delete(`${$config.backendURL}/items/${_id}`, authData)
        .then((res) => {
          dispatch("delete");
          loadData();
        })
        .catch((err) => {
          console.log(err);
          alert(err);
        });
    }
  };

  const handleAdd = () => {
    let qty = prompt(`Enter the quantity to add to stock. Example. 20`);
    qty = qty.replaceAll(/[^\d.-]/g, "");

    axios
      .put(`${$config.backendURL}/items/increment/${_id}`, { qty }, authData)
      .then((res) => {
        dispatch("delete");
        loadData();
      })
      .catch((err) => {
        console.log(err);
        alert(err);
      });
  };

  const handleStockTake = async () => {
    let qty = prompt(`Enter Stock take quantity. Example. 20`);
    qty = qty.replaceAll(/[^\d.-]/g, "");
    qty = Number.parseFloat(qty);

    let data = {
      inventoryLevel: qty,
      lastStockTake: new Date().toISOString().slice(0, 10),
    };

    let data2 = {
      itemID: _id,
      itemN: name,
      date: new Date().toISOString().slice(0, 10),
      qtyP: qty, // physical quantity
      qtyL: inventoryLevel, // logical quantity
    };

    await axios
      .post(`${$config.backendURL}/stocktake`, data2, authData)
      .catch((err) => {
        console.log(err);
        alert(err);
      });

    await axios
      .put(`${$config.backendURL}/items/${_id}`, data, authData)
      .then((res) => {
        dispatch("delete");
        loadData();
      })
      .catch((err) => {
        console.log(err);
        alert(err);
      });
  };

  let showFluxModal = false;

  const handleShowFlux = () => {
    console.log("showing modal");
    showFluxModal = true;
  };

  const handleChangePrice = () => {
    let price = prompt(`Enter the New Price. Example. 20`);
    price = price.replaceAll(/[^\d.-]/g, "");

    axios
      .put(`${$config.backendURL}/items/${_id}`, { price }, authData)
      .then((res) => {
        dispatch("delete");
        loadData();
      })
      .catch((err) => {
        console.log(err);
        alert(err);
      });
  };

  let getDays = (d2) => {
    let t2 = new Date().getTime();
    let t1 = new Date(d2).getTime();
    return Math.floor((t2 - t1) / (24 * 3600 * 1000));
  };
</script>

{#if /timber|foam|board|pine/.test(class_)}
  <div
    in:fade={{ duration: $config.f.time() }}
    class="tr border-b border-gray-100"
  >
    <div style="min-width: 15rem; max-width: 15rem;" class="flex items-center">
      <button
        class="text-base btn btn-red-outline mr-2"
        on:click={handleDelete}
      >
        <i class="fas fa-trash" />
      </button>
      <a
        href={`/products/${_id}`}
        use:link
        class="text-base btn btn-green-outline mr-2"
      >
        <i class="fas fa-eye" />
      </a>
      <button
        class="text-base btn btn-primary-outline mr-2"
        on:click={handleAdd}
      >
        <i class="fas fa-plus" />
      </button>
      <button
        class="text-base btn btn-gray-outline mr-2"
        on:click={handleStockTake}
        style="font-size: 0.65rem !important; padding: 0.4rem 0.2rem !important;"
      >
        STOCK TAKE
      </button>
    </div>
    <div style="min-width: 15rem; max-width: 15rem;">
      {name}
    </div>
    <div
      style="min-width: 10rem; max-width: 10rem;"
      class="text-xs uppercase flex items-center"
    >
      {#if lastStockTake}
        {lastStockTake}
        <div class="ml-1 text-brand flex items-center">
          ({getDays(lastStockTake) == 0
            ? "today"
            : `${getDays(lastStockTake)} days ago`})
        </div>
      {:else}
        NOT AVAILABLE
      {/if}
    </div>
    <div style="min-width: 6rem; max-width: 6rem;">
      {inventoryLevel || "🟥 used up"}
    </div>
    <div style="min-width: 6rem; max-width: 6rem;">
      {plankPrice}
    </div>
    <div style="min-width: 10rem; max-width: 10rem;">{lotNumber}</div>
    <div style="min-width: 6rem; max-width: 6rem;">{length}</div>
    <div style="min-width: 6rem; max-width: 6rem;">{width}</div>
    <div style="min-width: 6rem; max-width: 6rem;">{thickness}</div>
    <div style="min-width: 6rem; max-width: 6rem;">{bundlePrice}</div>
    <div style="min-width: 7.5rem; max-width: 7.5rem;">
      {Number(totalMM).toFixed(2)}
    </div>
    <div style="min-width: 6rem; max-width: 6rem;">{SKU}</div>

    <div style="min-width: 7.5rem; max-width: 7.5rem;">
      {plankNumber || ""}
    </div>
  </div>
{:else}
  <div
    in:fade={{ duration: $config.f.time() }}
    class="tr border-b border-gray-100"
  >
    <div style="min-width: 15rem; max-width: 15rem;" class="flex items-center">
      <button
        class="text-base btn btn-red-outline mr-2"
        on:click={handleDelete}
      >
        <i class="fas fa-trash" />
      </button>
      <a
        href={`/products/${_id}`}
        use:link
        class="text-base btn btn-green-outline mr-2"
      >
        <i class="fas fa-eye" />
      </a>
      <button
        class="text-base btn btn-primary-outline mr-2"
        on:click={handleAdd}
      >
        <i class="fas fa-plus" />
      </button>
      <button
        class="text-base btn btn-gray-outline mr-2"
        on:click={handleStockTake}
        style="font-size: 0.65rem !important; padding: 0.4rem 0.2rem !important;"
      >
        STOCK TAKE
      </button>
    </div>
    {#if inventoryLevel > reorderLevel}
      <div style="min-width: 20rem; max-width: 20rem;">
        {name}
      </div>
    {:else}
      <div
        style="min-width: 20rem; max-width: 20rem;"
        class="flex items-center text-red-500"
      >
        <div
          class="text-xs px-2 py-1 flex items-center bg-red-100 mr-2 rounded-md"
        >
          <i class="fas fa-exclamation-triangle mr-1" />
          Low
        </div>
        {name}
      </div>
    {/if}
    <div
      style="min-width: 10rem; max-width: 10rem;"
      class="text-xs uppercase flex items-center"
    >
      {#if lastStockTake}
        {lastStockTake}
        <div class="ml-1 text-brand flex items-center">
          ({getDays(lastStockTake) == 0
            ? "today"
            : `${getDays(lastStockTake)} days ago`})
        </div>
      {:else}
        NOT AVAILABLE
      {/if}
    </div>
    <div
      style="min-width: 6rem; max-width: 6rem;"
      class="flex justify-between items-center mr-4"
    >
      R{price}
      <button class="text-base btn btn-secondary" on:click={handleChangePrice}>
        <i class="fas fa-pen text-green-400" />
      </button>
    </div>
    <div style="min-width: 7.5rem; max-width: 7.5rem;">
      {inventoryLevel}
    </div>
    <div
      style="min-width: 6rem; max-width: 6rem;"
      class="flex justify-between items-center mr-4 text-gray-500"
    >
      R{Number(avg)?.toFixed(2)}
      {#if flux?.length > 1}
        <button
          class="ml-1 text-base btn btn-secondary"
          on:click={handleShowFlux}
        >
          <i class="fas fa-chart-line" />
        </button>
      {/if}
    </div>
    <div style="min-width: 7.5rem; max-width: 7.5rem;">
      {reorderLevel}
    </div>
    <div style="min-width: 10rem; max-width: 10rem;">{SKU}</div>
    <div style="min-width: 10rem; max-width: 10rem;">
      {$config?.suppliers?.find(({ value }) => value == supplierID)?.label ||
        "N/A"}
    </div>
    {#if class_ == "fabric"}
      <div style="min-width: 7rem; max-width: 7rem;">{materialProvider}</div>
    {/if}
    <div style="min-width: 7.5rem; max-width: 7.5rem;">
      R{mult(inventoryLevel, price)}
    </div>
  </div>
{/if}

{#if flux?.length > 0}
  <FluxViewModal
    title={name}
    {avg}
    on:modalClose={() => (showFluxModal = false)}
    show={showFluxModal}
    {flux}
  />
{/if}

<style>
  .tr {
    display: flex;
    align-items: center;
    width: max-content;
    padding: 10px 20px;
  }
</style>
